// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2QVQP","image":"Header_image__tQSOS","name":"Header_name__2f1A7","info":"Header_info__rkRp6","infoRow":"Header_infoRow__YLrh9"};